import script from "./SecCardGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SecCardGrid.vue?vue&type=script&setup=true&lang=js"

import "./SecCardGrid.vue?vue&type=style&index=0&id=2b405bba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b405bba"]])

export default __exports__